export default __webpack_public_path__ + "static/media/newLogoNavbar.ee2ce8bc.png";